import Testimonial from ".";

export const testimonialRoutes = () => [
  {
    path: "/admin/testimonial",
    title: "testimonial",
    layout: "admin",
    routeType: "admin",
    component: Testimonial,
  },
];
